export default __webpack_public_path__ + "static/featureSectionImg-2845737a17392df9f687c00ae0ca742d.png";